module.exports = __webpack_public_path__ + "img/smoke.f739284f.svg";